import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApiCategory, CatalogLayout, CatalogSort } from '../../core/models';

export const CatalogActions = createActionGroup({
  source: 'Catalog',
  events: {
    // Live category + products for the signed-in store/terminal.
    'Load Category Info': emptyProps(),
    'Load Category Info Success': props<{ categories: ApiCategory[] }>(),
    'Load Category Info Failure': props<{ error: string }>(),

    'Set Query': props<{ query: string }>(),
    'Clear Query': emptyProps(),
    'Set Category': props<{ category: string }>(),
    'Set Sort': props<{ sort: CatalogSort }>(),
    'Toggle In Stock Only': emptyProps(),
    'Set Layout': props<{ layout: CatalogLayout }>(),
    'Reset Filters': emptyProps(),

    'Open Product': props<{ id: string }>(),
  },
});
